import { loadStripe } from '@stripe/stripe-js'

export const stripePromise = loadStripe(
  // eslint-disable-next-line
  // @ts-ignore
  process.env.REACT_APP_VERCEL_ENV !== 'production'
    ? process.env.REACT_APP_STRIPE_PUBLISH_KEY_TEST
    : process.env.REACT_APP_STRIPE_PUBLISH_KEY
)
